import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, Send } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        frontend_url: window.location.origin,
      });
      setSent(true);
      toast.success("Si cet email existe, un lien vous a été envoyé.");
    } catch (err) {
      toast.error("Une erreur est survenue. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-12rem)] flex items-center bg-bone">
      <div className="container-jamm max-w-md mx-auto py-16">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-ink-soft hover:text-ink mb-4" data-testid="forgot-back-login">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <form onSubmit={submit} className="card-soft" data-testid="forgot-form">
          <h2 className="font-display text-3xl text-ink">Mot de passe oublié ?</h2>
          <p className="text-ink-soft mt-2 text-sm">
            Indiquez votre email — nous vous enverrons un lien sécurisé pour choisir un nouveau mot de passe.
          </p>

          {sent ? (
            <div className="mt-6 rounded-xl bg-sage-50 border border-sage-200 text-sage-700 p-4 text-sm" data-testid="forgot-success">
              <p className="font-medium">📬 Vérifiez votre boîte mail.</p>
              <p className="mt-1">Si l'adresse <strong>{email}</strong> est associée à un compte, vous recevrez un lien valable 1 heure pour réinitialiser votre mot de passe.</p>
              <p className="mt-2 text-xs text-sage-600">N'oubliez pas de vérifier vos spams.</p>
            </div>
          ) : (
            <>
              <label className="block mt-6 text-sm text-ink-soft">Email</label>
              <div className="mt-1.5 flex items-center rounded-xl border border-border bg-white px-3 focus-within:ring-2 focus-within:ring-sage-300">
                <Mail className="w-4 h-4 text-ink-mute" />
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-3 py-3 bg-transparent focus:outline-none"
                  placeholder="vous@email.com"
                  data-testid="forgot-email"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center mt-6" data-testid="forgot-submit">
                {loading ? "Envoi…" : (<><Send className="w-4 h-4" /> Envoyer le lien</>)}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
